import store from "@/store/main"

export default {
    canManageDiscounts() {
        return this.hasAccessToUnderCeoLevel('ROLE_DISCOUNT_MANAGER')
    },
    canManageServices() {
        return this.hasAccessToUnderCeoLevel('ROLE_SERVICE_MANAGER')
    },
    canWriteOffProductInWarehouse() {
        return this.hasAccessToUnderCeoLevel('ROLE_PRODUCT_WRITE_OFFTER')
    },
    canSeeServiceHistory() {
        if (this.canManageServices()) {
            return true
        }

        return this.hasAccessToUnderCeoLevel('ROLE_SERVICE_HISTORY')
    },
    canManageTaxes() {
        return this.hasAccessToUnderCeoLevel('ROLE_TAXES_MANAGER')
    },
    canAutoOrder() {
        return this.hasAccessToUnderCeoLevel('ROLE_AUTOORDER_MANAGER')
    },
    canSale() {
        return this.hasAccessToUnderCeoLevel('ROLE_SELLER')
    },
    canSeeSaleHistory() {
        if (this.canSale()) {
            return true
        }

        return this.hasAccessToUnderCeoLevel('ROLE_SALE_HISTORY')
    },
    canStoreKeeping() {
        return this.hasAccessToUnderCeoLevel('ROLE_STOREKEEPER')
    },
    canManageProducts() {
        return this.hasAccessToUnderCeoLevel('ROLE_PRODUCT_MANAGER')
    },
    canPurchaseProducts() {
        return this.hasAccessToUnderCeoLevel('ROLE_PRODUCT_PURCHASER')
    },
    canSeeProductPurchasesHistory() {
        if (this.canPurchaseProducts()) {
            return true
        }

        return this.hasRole('ROLE_PRODUCT_PURCHASE_HISTORY')
    },
    canManageCustomers() {
        return this.hasAccessToUnderCeoLevel('ROLE_CUSTOMER_MANAGER')
    },
    canSeeCustomerDebts() {
        return this.hasAccessToUnderCeoLevel('ROLE_SEE_CUSTOMER_DEBTS')
    },
    canManagerSuppliers() {
        return this.hasAccessToUnderCeoLevel('ROLE_SUPPLIER_MANAGER')
    },
    canSeeSupplierDebts() {
        return this.hasAccessToUnderCeoLevel('ROLE_SEE_SUPPLIER_DEBTS')
    },
    canManageEmployees() {
        return this.hasAccessToUnderCeoLevel('ROLE_EMPLOYEE_MANAGER')
    },
    canManageKpis() {
        return this.hasAccessToUnderCeoLevel('ROLE_KPI_MANAGER')
    },
    canManageCompany() {
        return this.hasAccessToUnderCeoLevel('ROLE_COMPANY_MANAGER')
    },
    canSeeCompanyInfo() {
        return this.hasAccessToUnderCeoLevel('ROLE_COMPANY_INFO')
    },
    canSeeStatisticsInfo() {
        return this.hasAccessToUnderCeoLevel('ROLE_STATISTICS_INFO')
    },
    canDeleteSaleHistory() {
        return this.hasAccessToUnderCeoLevel('ROLE_CAN_DELETE_SALE_HISTORY')
    },
    canMakeInventory() {
        return this.hasAccessToUnderCeoLevel('ROLE_INVENTORY_MAKER')
    },

    hasRoleCeo() {
        return this.hasRole('ROLE_CEO')
    },
    hasRoleAdmin() {
        return this.hasRole('ROLE_ADMIN')
    },
    hasRoleCeoOrAdmin() {
        if (this.hasRoleCeo()) {
            return true;
        }

        return this.hasRoleAdmin();
    },
    hasRole(roleName) {
        return store.getters.getUserRoles.includes(roleName)
    },
    hasAccessStatistics() {
        switch (store.getters.getUserCompany.plans[0].planType.name) {
            case "free":
            case "liteM":
            case "liteA":
            case "standartM":
            case "standartA":
            case "premiumM":
            case "premiumA":
                return true
        }

        return false
    },
    hasAccessFinance() {
        switch (store.getters.getUserCompany.plans[0].planType.name) {
            case "free":
            case "standartM":
            case "standartA":
            case "premiumM":
            case "premiumA":
                return true
        }

        return false
    },
    hasAccessToUnderCeoLevel(roleName) {
        if (this.hasRoleCeoOrAdmin()) {
            return true
        }

        return this.hasRole(roleName)
    },
}
